// extracted by mini-css-extract-plugin
module.exports =  {"navLinkColor":"rgba(0, 0, 0, 0.38)","navLinkColorActive":"rgba(0, 0, 0, 0.87)","link":"link--SEjh2","active":"active--p47AY"};